import styled from "styled-components";

const UILink = styled.a.attrs({ className: "link" })`
  color: ${props => props.theme.colors.solera};
  font-size: 14px;
  text-decoration: none;
  &:hover {
    color: ${props => props.theme.colors.soleraDark};
  }
`;

UILink.displayName = "UILink";

export default UILink;
